<template>
  <div class="line-component" :style="computedStyle">
    <div class="line" :style="lineStyle"></div>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
export default {
  mixins: [eventMixin],
  name: "cxVerticalLine",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  mounted() {},
  computed: {
    computedStyle() {
      return {
        // top: this.options.top,
        "z-index": this.options.zIndex,
      }
    },
    lineStyle() {
      let isThemeColor = this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false
      // 双虚线
      let ifDouble = this.options.lineType == "doubleDotted" ? true : false
      return {
        height: "100%",
        opacity: this.options.opacity / 100,
        width: this.options.borderWidth === 1 ? '2px' : 'auto',
        "border-width": ifDouble ? this.options.borderWidth / 2  + "px" : this.options.borderWidth + "px",
        // "border-color": isThemeColor ? this.$store.state[this.request_prefix].page.themeColor : (this.options.bgColor.color ? this.options.bgColor.color : this.options.bgColor),
        "border-color": this.$parseColor(this.options.bgColor, {
          isThemeColor: isThemeColor
        }),
        "border-left-style": ifDouble ? "dashed" : this.options.lineType,
        "border-right-style": ifDouble ? "dashed" : "",
      }
    }
  },
  methods: {
    async updateData() {}
  }
}
</script>

<style scoped>
  .line-component {
    width: 100%;
    height: 100%;
  }
  .line-component .line {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
</style>
